import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface ContentState {
  homeContent: any | null
  aboutContent: any | null
  servicesContent: any | null
  projectsContent: any | null
  contactContent: any | null
  isLoading: boolean
  error: string | null
}

const initialState: ContentState = {
  homeContent: null,
  aboutContent: null,
  servicesContent: null,
  projectsContent: null,
  contactContent: null,
  isLoading: false,
  error: null,
}

const contentSlice = createSlice({
  name: 'content',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
    },
    setHomeContent: (state, action: PayloadAction<any>) => {
      state.homeContent = action.payload
    },
    setAboutContent: (state, action: PayloadAction<any>) => {
      state.aboutContent = action.payload
    },
    setServicesContent: (state, action: PayloadAction<any>) => {
      state.servicesContent = action.payload
    },
    setProjectsContent: (state, action: PayloadAction<any>) => {
      state.projectsContent = action.payload
    },
    setContactContent: (state, action: PayloadAction<any>) => {
      state.contactContent = action.payload
    },
  },
})

export const {
  setLoading,
  setError,
  setHomeContent,
  setAboutContent,
  setServicesContent,
  setProjectsContent,
  setContactContent,
} = contentSlice.actions

export default contentSlice.reducer
